import { useEffect } from 'react';

const defaults = {
  onlyTop: false,
};

export const useMouseOut = (options, callback) => {
  const settings = Object.assign({}, defaults, options);

  useEffect(() => {
    if (window) {
      const onMouseOut = e => {
        e = e ? e : window.event;
        let from = e.relatedTarget || e.toElement;

        const elementCondition = !from || from.nodeName == 'HTML';
        const directionCondition = settings.onlyTop ? e.clientY < 10 && e.clientY > -10 : true;

        if (!elementCondition || !directionCondition) {
          return;
        }

        callback();
      };

      window.addEventListener('mouseout', onMouseOut);

      return () => {
        window.removeEventListener('mouseout', onMouseOut);
      };
    }
  });
};
